import produce from 'immer';
import {
  DRAW_ITEM_EVENT_CREATE_REQUEST,
  DRAW_ITEM_EVENT_INFO_REQUEST,
  DRAW_ITEM_EVENT_LIST_REQUEST,
  DRAW_ITEM_EVENT_LOG_INFO_REQUEST,
  DRAW_ITEM_EVENT_REMOVE_REQUEST,
  DRAW_ITEM_EVENT_UPDATE_REQUEST
} from '../../constants/event/drawItemEventConstants';

const initialState = {

};

const drawItemEventReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case DRAW_ITEM_EVENT_LIST_REQUEST:
      break;
    case DRAW_ITEM_EVENT_CREATE_REQUEST:
      break;
    case DRAW_ITEM_EVENT_INFO_REQUEST:
      break;
    case DRAW_ITEM_EVENT_LOG_INFO_REQUEST:
      break;
    case DRAW_ITEM_EVENT_REMOVE_REQUEST:
      break;
    case DRAW_ITEM_EVENT_UPDATE_REQUEST:
      break;
    default:
      break;
  }
});

export default drawItemEventReducer;
